import type { FormVariant } from "@shared/types";

export const grindsByBagSize = (variants: FormVariant[]): Map<string, string[]> => {
  const bagSizeToGrindSet = new Map<string, Set<string>>();

  for (const variant of variants) {
    if (!variant.hasDetectedBagSize || !variant.bagSize) {
      continue;
    }
    const bagSize = variant.mapDetectedBagSizeTo ?? variant.bagSize;

    const grinds = variant.grind;
    if (!grinds || grinds.length === 0) continue;

    if (!bagSizeToGrindSet.has(bagSize)) {
      bagSizeToGrindSet.set(bagSize, new Set());
    }
    const grindsSet = bagSizeToGrindSet.get(bagSize);
    grinds.forEach((grind) => grindsSet?.add(grind));
  }

  const result = new Map<string, string[]>();
  for (const [bagSize, grinds] of bagSizeToGrindSet) {
    result.set(bagSize, Array.from(grinds));
  }
  return result;
};
